import { render, staticRenderFns } from "./MailboxModal.vue?vue&type=template&id=3d908cfc&"
import script from "./MailboxModal.vue?vue&type=script&lang=js&"
export * from "./MailboxModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d908cfc')) {
      api.createRecord('3d908cfc', component.options)
    } else {
      api.reload('3d908cfc', component.options)
    }
    module.hot.accept("./MailboxModal.vue?vue&type=template&id=3d908cfc&", function () {
      api.rerender('3d908cfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/admin/apps/mailbox/MailboxModal.vue"
export default component.exports